import { render, staticRenderFns } from "./roadmaps.vue?vue&type=template&id=90e81e38&scoped=true&"
import script from "./roadmaps.vue?vue&type=script&lang=js&"
export * from "./roadmaps.vue?vue&type=script&lang=js&"
import style0 from "./roadmaps.vue?vue&type=style&index=0&id=90e81e38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e81e38",
  null
  
)

export default component.exports